// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * MailChimp Syncs Styles
 * Modern, responsive styles for MailChimp sync management
 */

.mailchimp-syncs {
  padding: 24px;
  background:
    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),
    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

/* Header */
.syncs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  padding: 24px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.header-content h2 {
  color: #2d3748;
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  line-height: 1.2;
}

.header-content p {
  color: #4a5568;
  font-size: 1rem;
  margin: 0;
  line-height: 1.5;
}

.header-actions {
  display: flex;
  gap: 12px;
}

/* Statistics */
.syncs-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.15),
    0 4px 12px rgba(0, 0, 0, 0.08);
}

.stat-card.synced .stat-icon {
  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);
}

.stat-card.pending .stat-icon {
  background: linear-gradient(135deg, #d69e2e 0%, #b7791f 100%);
}

.stat-card.failed .stat-icon {
  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);
}

.stat-card.subscribed .stat-icon {
  background: linear-gradient(135deg, #3182ce 0%, #2c5aa0 100%);
}

.stat-icon {
  font-size: 2rem;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: white;
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
}

.stat-content h3 {
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0 0 4px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-value {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
}

/* Filters */
.mailchimp-sync-filters {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.filters-content {
  display: flex;
  gap: 20px;
  align-items: end;
}

.search-section {
  flex: 1 1;
}

.search-input-group {
  position: relative;
}

.search-input {
  width: 100%;
  padding: 12px 16px 12px 40px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  color: #2d3748;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.search-input:focus {
  outline: none;
  border-color: #0D3B66;
  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.1);
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #a0aec0;
  font-size: 1rem;
}

.filters-section {
  display: flex;
  gap: 16px;
  align-items: end;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.filter-label {
  color: #4a5568;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filter-select {
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  color: #2d3748;
  font-size: 0.9rem;
  min-width: 150px;
  transition: all 0.3s ease;
}

.filter-select:focus {
  outline: none;
  border-color: #0D3B66;
  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.1);
}

.filters-actions {
  display: flex;
  gap: 12px;
}

/* Bulk Actions */
.bulk-actions {
  background: rgba(102, 126, 234, 0.1);
  border: 1px solid rgba(102, 126, 234, 0.2);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
}

.bulk-actions-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.selected-count {
  color: #2d3748;
  font-weight: 600;
  font-size: 0.9rem;
}

.bulk-controls {
  display: flex;
  gap: 12px;
  align-items: center;
}


/* Syncs Table */
.syncs-table {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  overflow: hidden;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.syncs-table table {
  width: 100%;
  border-collapse: collapse;
}

.syncs-table th {
  background: rgba(102, 126, 234, 0.1);
  color: #2d3748;
  font-weight: 600;
  padding: 16px;
  text-align: left;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.syncs-table td {
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  color: #4a5568;
}

.syncs-table tr:hover {
  background: rgba(102, 126, 234, 0.05);
}

/* Status Badge */
.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge.synced {
  background: rgba(56, 161, 105, 0.1);
  color: #38a169;
}

.status-badge.pending {
  background: rgba(214, 158, 46, 0.1);
  color: #d69e2e;
}

.status-badge.failed {
  background: rgba(229, 62, 62, 0.1);
  color: #e53e3e;
}

.status-badge.unsubscribed {
  background: rgba(113, 128, 150, 0.1);
  color: #718096;
}

.status-badge.cleaned {
  background: rgba(160, 174, 192, 0.1);
  color: #a0aec0;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.empty-icon {
  font-size: 4rem;
  margin-bottom: 20px;
  opacity: 0.6;
}

.empty-state h3 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 12px 0;
}

.empty-state p {
  color: #4a5568;
  font-size: 1rem;
  margin: 0;
  line-height: 1.5;
}

/* Loading */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-outline {
  background: transparent;
  color: #0D3B66;
  border: 1px solid #0D3B66;
}

.btn-outline:hover:not(:disabled) {
  background: #0D3B66;
  color: white;
}

.btn-sm {
  padding: 6px 12px;
  font-size: 0.8rem;
}

.btn-icon {
  font-size: 1rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .mailchimp-syncs {
    padding: 16px;
  }

  .syncs-header {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }

  .header-actions {
    width: 100%;
    justify-content: center;
  }

  .syncs-stats {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  .filters-content {
    flex-direction: column;
    align-items: stretch;
  }

  .filters-section {
    flex-direction: column;
    gap: 12px;
  }

  .filter-select {
    min-width: auto;
  }

  .bulk-actions-content {
    flex-direction: column;
    align-items: stretch;
  }

  .bulk-controls {
    flex-direction: column;
    gap: 8px;
  }

  .syncs-table {
    overflow-x: auto;
  }

  .syncs-table table {
    min-width: 600px;
  }

}

@media (max-width: 480px) {
  .mailchimp-syncs {
    padding: 12px;
  }

  .syncs-header {
    padding: 16px;
  }

  .header-content h2 {
    font-size: 1.5rem;
  }

  .syncs-stats {
    grid-template-columns: 1fr;
  }

  .stat-card {
    padding: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/mailchimp/MailChimpSyncs.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb;;;qDAGmD;EACnD,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;;iCAE+B;EAC/B,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B;;kCAEgC;AAClC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB;;iCAE+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;;AAGA,gBAAgB;AAChB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB;;iCAE+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;AAEF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/**\n * MailChimp Syncs Styles\n * Modern, responsive styles for MailChimp sync management\n */\n\n.mailchimp-syncs {\n  padding: 24px;\n  background:\n    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),\n    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  min-height: 100vh;\n}\n\n/* Header */\n.syncs-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  padding: 24px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    0 4px 16px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.header-content h2 {\n  color: #2d3748;\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  line-height: 1.2;\n}\n\n.header-content p {\n  color: #4a5568;\n  font-size: 1rem;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.header-actions {\n  display: flex;\n  gap: 12px;\n}\n\n/* Statistics */\n.syncs-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 20px;\n  margin-bottom: 32px;\n}\n\n.stat-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow:\n    0 8px 24px rgba(0, 0, 0, 0.15),\n    0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.stat-card.synced .stat-icon {\n  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);\n}\n\n.stat-card.pending .stat-icon {\n  background: linear-gradient(135deg, #d69e2e 0%, #b7791f 100%);\n}\n\n.stat-card.failed .stat-icon {\n  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);\n}\n\n.stat-card.subscribed .stat-icon {\n  background: linear-gradient(135deg, #3182ce 0%, #2c5aa0 100%);\n}\n\n.stat-icon {\n  font-size: 2rem;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: white;\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n}\n\n.stat-content h3 {\n  color: #4a5568;\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin: 0 0 4px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stat-value {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0;\n  line-height: 1.2;\n}\n\n/* Filters */\n.mailchimp-sync-filters {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 24px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.filters-content {\n  display: flex;\n  gap: 20px;\n  align-items: end;\n}\n\n.search-section {\n  flex: 1;\n}\n\n.search-input-group {\n  position: relative;\n}\n\n.search-input {\n  width: 100%;\n  padding: 12px 16px 12px 40px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: white;\n  color: #2d3748;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #0D3B66;\n  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.1);\n}\n\n.search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #a0aec0;\n  font-size: 1rem;\n}\n\n.filters-section {\n  display: flex;\n  gap: 16px;\n  align-items: end;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.filter-label {\n  color: #4a5568;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.filter-select {\n  padding: 12px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: white;\n  color: #2d3748;\n  font-size: 0.9rem;\n  min-width: 150px;\n  transition: all 0.3s ease;\n}\n\n.filter-select:focus {\n  outline: none;\n  border-color: #0D3B66;\n  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.1);\n}\n\n.filters-actions {\n  display: flex;\n  gap: 12px;\n}\n\n/* Bulk Actions */\n.bulk-actions {\n  background: rgba(102, 126, 234, 0.1);\n  border: 1px solid rgba(102, 126, 234, 0.2);\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 24px;\n}\n\n.bulk-actions-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.selected-count {\n  color: #2d3748;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.bulk-controls {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n\n/* Syncs Table */\n.syncs-table {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.syncs-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.syncs-table th {\n  background: rgba(102, 126, 234, 0.1);\n  color: #2d3748;\n  font-weight: 600;\n  padding: 16px;\n  text-align: left;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.syncs-table td {\n  padding: 16px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  color: #4a5568;\n}\n\n.syncs-table tr:hover {\n  background: rgba(102, 126, 234, 0.05);\n}\n\n/* Status Badge */\n.status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-badge.synced {\n  background: rgba(56, 161, 105, 0.1);\n  color: #38a169;\n}\n\n.status-badge.pending {\n  background: rgba(214, 158, 46, 0.1);\n  color: #d69e2e;\n}\n\n.status-badge.failed {\n  background: rgba(229, 62, 62, 0.1);\n  color: #e53e3e;\n}\n\n.status-badge.unsubscribed {\n  background: rgba(113, 128, 150, 0.1);\n  color: #718096;\n}\n\n.status-badge.cleaned {\n  background: rgba(160, 174, 192, 0.1);\n  color: #a0aec0;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    0 4px 16px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.empty-icon {\n  font-size: 4rem;\n  margin-bottom: 20px;\n  opacity: 0.6;\n}\n\n.empty-state h3 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n}\n\n.empty-state p {\n  color: #4a5568;\n  font-size: 1rem;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Loading */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n/* Buttons */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.btn-outline {\n  background: transparent;\n  color: #0D3B66;\n  border: 1px solid #0D3B66;\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: #0D3B66;\n  color: white;\n}\n\n.btn-sm {\n  padding: 6px 12px;\n  font-size: 0.8rem;\n}\n\n.btn-icon {\n  font-size: 1rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .mailchimp-syncs {\n    padding: 16px;\n  }\n\n  .syncs-header {\n    flex-direction: column;\n    gap: 16px;\n    text-align: center;\n  }\n\n  .header-actions {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .syncs-stats {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 16px;\n  }\n\n  .filters-content {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .filters-section {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .filter-select {\n    min-width: auto;\n  }\n\n  .bulk-actions-content {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .bulk-controls {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .syncs-table {\n    overflow-x: auto;\n  }\n\n  .syncs-table table {\n    min-width: 600px;\n  }\n\n}\n\n@media (max-width: 480px) {\n  .mailchimp-syncs {\n    padding: 12px;\n  }\n\n  .syncs-header {\n    padding: 16px;\n  }\n\n  .header-content h2 {\n    font-size: 1.5rem;\n  }\n\n  .syncs-stats {\n    grid-template-columns: 1fr;\n  }\n\n  .stat-card {\n    padding: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
